import React from 'react';


const CompletionTrendChart = () => {
  const trendData = [
    { month: 'Jul', completion: 72, participants: 45 },
    { month: 'Aug', completion: 78, participants: 52 },
    { month: 'Sep', completion: 85, participants: 58 },
    { month: 'Oct', completion: 82, participants: 55 },
    { month: 'Nov', completion: 88, participants: 62 },
    { month: 'Dec', completion: 85, participants: 60 }
  ];

  const maxCompletion = Math.max(...trendData?.map(d => d?.completion));

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Completion Trend</h3>
          <p className="text-sm text-muted-foreground">6-month audit completion rate overview</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span className="text-sm text-muted-foreground">Completion %</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-purple-500"></div>
            <span className="text-sm text-muted-foreground">Participants</span>
          </div>
        </div>
      </div>
      <div className="h-64 flex items-end justify-between gap-4">
        {trendData?.map((data, index) => {
          const height = (data?.completion / maxCompletion) * 100;
          const participantHeight = (data?.participants / 70) * 100;

          return (
            <div key={index} className="flex-1 flex flex-col items-center">
              <div className="w-full flex items-end justify-center gap-1 mb-2" style={{ height: '200px' }}>
                <div
                  className="w-full bg-primary rounded-t-lg transition-all hover:opacity-80 cursor-pointer relative group"
                  style={{ height: `${height}%` }}
                >
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-foreground text-background px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {data?.completion}% completion
                  </div>
                </div>
                <div
                  className="w-full bg-purple-500 rounded-t-lg transition-all hover:opacity-80 cursor-pointer relative group"
                  style={{ height: `${participantHeight}%` }}
                >
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-foreground text-background px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {data?.participants} users
                  </div>
                </div>
              </div>
              <span className="text-xs font-medium text-muted-foreground">{data?.month}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompletionTrendChart;